"use client";

import type { FC } from "react";
import { InquiriesTable } from "../inquiries-table";
import { InquiryNewBadge } from "../inquiry-new-badge";
import { useUnreadInquiriesCount } from "../../hooks/use-inquiries";

/** `/dashboard/enquiries` — Figma 2:12861. */
export const EnquiriesPage: FC = () => {
  const { data } = useUnreadInquiriesCount();
  const unread = data?.count ?? 0;

  return (
    <div className="flex flex-col gap-32">
      <div className="flex flex-col gap-8">
        <div className="flex flex-wrap items-center gap-8">
          <h1 className="text-32 leading-[1.3] text-neutral-black">Manage incoming enquiries</h1>
          {unread > 0 && <InquiryNewBadge size="l">{unread} New</InquiryNewBadge>}
        </div>
        <p className="text-16 leading-[1.7] text-neutral-black/75">
          Every enquiry sent to you from the CMW directory, newest first.
        </p>
      </div>
      <hr className="border-neutral-light-grey" />
      <InquiriesTable />
    </div>
  );
};
